import { Breadcrumb } from 'antd'
import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { useProducts } from '@api/hernest/products/useProducts'
import { dispatchGlobalEvent } from '@hooks/useGlobalEvent'
import useLoadMore from '@hooks/useLoadMore'
import { Image, Pagination, SkeletonImg, Switch } from '@ui-pc'
import { ViewMore } from '@ui-pc/Widget-yoptV2'
import { transTimeToDate } from '@utils'
import { pathnameToPage } from '@utils/winPixel'

import winPixel from '../../../../../ind/api/hernest/winPixel_pc.bak'
import listEmpty from '../../assets/imgs/listEmpty.png'
import pcFlashBg from '../../assets/imgs/pc_flash_bg.png'
import ProductList from '../../components/ProductList'
import FAQ from './components/FAQ'
import FilterSort from './components/FilterSort'
import FixedFilter from './components/FixedFilter'
import FlashCountdown from './components/FlashCountdown'
import SortBy from './components/SortBy'
import styles from './index.module.scss'

interface IProductsProps {
  isSearch?: boolean
  isCategory?: boolean
  isCustompro?: boolean
  params?: any | undefined
  initLoading?: boolean
  showSkeletonList?: boolean
  pageType?: number
  onFetch?: Function
  onChangePage?: Function | undefined
  isCustomTitle?
  isFlash?: boolean
  isFeed?: boolean
  isViewMore?
  endTimeCallback?: Function
  onFilter?
  hideFilter?: boolean
  toggleFilter?: Function
}

const Products: React.FunctionComponent<IProductsProps> = (props) => {
  const {
    isSearch,
    isCategory,
    isCustompro,
    isFlash,
    isFeed,
    params,
    initLoading,
    showSkeletonList,
    isViewMore,
    endTimeCallback,
    hideFilter,
    toggleFilter
  } = props

  const {
    navBread,
    breadcrumbItems,
    pageName,
    productList,
    categoriesImg,
    categoryName,
    categoriesDescription,
    pageTitle,
    pageDesc,
    filterData,
    productCount,
    pageSize,
    changeAttrSelect,
    productsData,
    display,
    sliderDisplay,
    removeActive,
    removeSwitch,
    removeAll,
    page,
    changePage,
    handleChangeSort,
    sortLabelShow,
    banners,
    flashEndTime
  } = useProducts(false, props)

  const fdBanner = banners?.flashDealBanner || {}
  const fdBannerIamge = Array.isArray(fdBanner?.bannersImage)
    ? fdBanner?.bannersImage[0]
    : []

  const sortLabelRef = React.useRef('')

  React.useEffect(() => {
    if (productList && productList.length > 0) {
      winPixel.viewItemList(
        productList,
        location.pathname.split('/')[1],
        sortLabelRef.current
      )
    }
  }, [productList, sortLabelRef])

  const location = useLocation()

  // 收集用户兴趣
  useEffect(() => {
    if (isSearch) {
      params.keywords &&
        winPixel.setUserTag(
          `${pathnameToPage(location.pathname)}@${decodeURIComponent(
            params.keywords
          )}`
        )
    }

    if (isCategory || isCustompro) {
      const pageName = pathnameToPage(location.pathname)
      params.catId &&
        pageName != 'Item' &&
        winPixel.setUserTag(`${pageName}@${params.catId}`)
    }
  }, [params])

  const [size, useSize] = React.useState(24)

  // 左侧栏 + 顶部固定筛选共用
  const filterCommonProps = {
    hideOnSale: true,
    showInStock: Number(filterData.isShowInStock) === 1, // 现货、清仓集合页隐藏
    showQuickShip: Number(filterData.isShowQuickShip) === 1,
    initData: productsData?.data,
    data: filterData.filterList,
    handleChange: (obj) => {
      changeAttrSelect({ ...obj, manualControl: 1 })
      props.onFilter?.()
    },
    filterForm: params
  }
  const hasTextBanner =
    categoryName || pageTitle || categoriesDescription || pageDesc

  // console.log(
  //   'normalParams',
  //   isCategory ||
  //     isSearch ||
  //     isFlash ||
  //     isCustompro ||
  //     !(hideFilter && isViewMore)
  // )

  return (
    <>
      <div className={styles['products']}>
        {/* 面包屑 */}
        <Switch either={(isCategory || isSearch) && navBread?.length}>
          <div id='js-bread' className='global-wrap'>
            <Breadcrumb items={breadcrumbItems} separator='/' />
          </div>
        </Switch>
        <div
          className={`${styles['banner-container']} products-category-banner`}
          id='js-productBanner'
        >
          {/* 类目页/自定义产品集合页---有类目图片 + 标题  */}
          <Switch either={isCategory || isCustompro}>
            <Switch either={initLoading}>
              <SkeletonImg />
              <div
                className={`${styles['main-banner']} ${
                  categoriesImg
                    ? `${styles['has-cate-img']} ${hasTextBanner && styles['has-cate-textBanner']}`
                    : `${styles['noImg']} ${isCustompro && styles['customNoImg']}`
                }`}
              >
                <Switch either={categoriesImg}>
                  {/* <Image
                    alt={' '}
                    preview={false}
                    src={categoriesImg || 'void'}
                    isLong={true}
                  /> */}
                  <img src={categoriesImg} />
                </Switch>
                <div className={styles['title-desc-box']}>
                  <Switch either={categoryName || pageTitle}>
                    <div className={styles['category-products-title']}>
                      {categoryName || pageTitle}
                    </div>
                  </Switch>
                  <Switch either={categoriesDescription || pageDesc}>
                    <div className={styles['products-desc']}>
                      {categoriesDescription || pageDesc}
                    </div>
                  </Switch>
                </div>
              </div>
            </Switch>
          </Switch>
          {/* 闪购页，含倒计时 */}
          <Switch either={isFlash}>
            <div className={styles['products-flash-bg']}>
              <img src={fdBannerIamge?.image} />
              <div className={`global-wrap ${styles['flash-text-box']}`}>
                <section className={styles['flash-title']}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: fdBanner?.bannersTitle
                    }}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: fdBanner?.bannersExtra?.bannersSubtitle
                    }}
                  />
                </section>
                <section className={styles['flash-time']}>
                  <FlashCountdown
                    second={flashEndTime ? flashEndTime : 0}
                    data={{}}
                    endTimeCallback={endTimeCallback}
                  />
                </section>
              </div>
            </div>
          </Switch>
          {/* 热销、新品 标题*/}
          <Switch either={!isFlash && pageName && productList?.length}>
            <div className={styles['products-other-title-bg']}>
              <img src={pcFlashBg} />
            </div>
          </Switch>
        </div>

        <div
          className={`global-wrap products-for-feed ${styles['products-mainBox']}`}
        >
          {/* 搜索页标题 */}
          <Switch either={isSearch}>
            <div
              className={styles['products-keyword-title']}
              id='js-searchTitle'
            >
              Showing results for "
              {params.keywords ? decodeURIComponent(params.keywords) : ''}"
            </div>
          </Switch>

          <div className={styles['products-top']}>
            {/* show filter */}
            <Switch
              either={
                filterData?.filterList?.length &&
                (isSearch || isCategory || isFlash || isCustompro)
              }
            >
              <div
                className={styles['pTop-left']}
                onClick={() => toggleFilter()}
              >
                <i className='iconfont icon-Filter'></i>
                {!hideFilter ? 'Hide' : 'Show'} Filter
              </div>
            </Switch>
            {/* 顶部固定筛选 */}
            <Switch either={hideFilter}>
              <div className={styles['pTop-middle']}>
                <FixedFilter {...filterCommonProps} />
              </div>
            </Switch>

            {/* 排序 */}
            <div className={styles['pTop-right']}>
              <div className={styles['product-nums']}>{productCount} ITEMS</div>
              <Switch either={filterData.orderSelect?.length}>
                <SortBy
                  filterForm={params}
                  filterData={filterData}
                  handleChangeSort={handleChangeSort}
                  sortLabel={sortLabelRef}
                  sortLabelShow={sortLabelShow}
                />
              </Switch>
            </div>
          </div>
          {/* 选中属性 */}
          <Switch
            either={
              display?.length > 0 ||
              sliderDisplay?.length > 0 ||
              Number(params.onSale) === 1 ||
              Number(params.inStock) === 1 ||
              Number(params.quickShip) === 1
            }
          >
            <div className={styles['active-filter']}>
              {display.length
                ? display.map((ele: any, i) => {
                    return (
                      <div
                        key={i}
                        className={styles['active-filter-item']}
                        onClick={() =>
                          removeActive(
                            ele.productsOptionsValuesId || String(ele.id),
                            ele.productsOptionsId == 'c' ||
                              ele.productsOptionsId == 's'
                              ? 'filterCat'
                              : 'filterValueIds',
                            false
                          )
                        }
                      >
                        {ele.productsOptionsId === 'p'
                          ? `Price ${ele.productsOptionsValuesName}`
                          : ele.productsOptionsValuesName || ele.categoriesName}
                        <i className='iconfont icon-close'></i>
                      </div>
                    )
                  })
                : null}
              {/* 滑动区间 */}
              {sliderDisplay?.map((k, i) => {
                return (
                  <div
                    key={i}
                    className={styles['active-filter-item']}
                    onClick={() => removeActive('', k.label, true)}
                  >
                    {k.label === 'Price' ? (
                      <>
                        {k.label} {k.valueUnit}
                        {params[`min${k.label}`]}&nbsp;to&nbsp;{k.valueUnit}
                        {params[`max${k.label}`]}
                      </>
                    ) : (
                      <>
                        {k.label} {params[`min${k.label}`]}
                        {k.valueUnit}&nbsp;-&nbsp;{params[`max${k.label}`]}
                        {k.valueUnit}
                      </>
                    )}
                    <i className='iconfont icon-close'></i>
                  </div>
                )
              })}
              {/* on sale */}
              {Number(params.onSale) === 1 && (
                <div
                  className={styles['active-filter-item']}
                  onClick={() => removeSwitch('onSale')}
                >
                  On Sale
                  <i className='iconfont icon-close'></i>
                </div>
              )}
              {/* quick ship */}
              {Number(params.quickShip) === 1 && (
                <div
                  className={styles['active-filter-item']}
                  onClick={() => removeSwitch('quickShip')}
                >
                  Quick Ship (Ships Under 5 Weeks)
                  <i className='iconfont icon-close'></i>
                </div>
              )}
              {/* in stock */}
              {Number(params.inStock) === 1 && (
                <div
                  className={styles['active-filter-item']}
                  onClick={() => removeSwitch('inStock')}
                >
                  In Stock (Ships Under 1 Week)
                  <i className='iconfont icon-close'></i>
                </div>
              )}
              <div className={styles['clear-all']} onClick={() => removeAll()}>
                Clear All
              </div>
            </div>
          </Switch>
          {/* 左侧筛选， 右侧产品 */}
          <div className={styles['products-flex']}>
            <Switch
              either={
                filterData?.filterList?.length &&
                (isSearch || isCategory || isFlash || isCustompro)
              }
            >
              <div
                className={`${styles['section-left']} ${
                  hideFilter && styles['filter-hide']
                }`}
              >
                <div className={styles['cate-filters-container']}>
                  <FilterSort {...filterCommonProps} />
                </div>
              </div>
            </Switch>
            <div className={styles['section-right']}>
              {productList?.length ? (
                <>
                  <ProductList
                    column={
                      isCategory || isSearch || isFlash || isCustompro
                        ? hideFilter && isViewMore
                          ? 4
                          : 3
                        : 4
                    }
                    list={productList}
                    isFeed={isFeed}
                    showAddCart={isViewMore}
                    showSoldOut={true}
                    showStartInFd={isFlash}
                    showSkeletonList={showSkeletonList}
                    name={sortLabelRef.current}
                  />
                  <div className={styles['page-bottom']}>
                    <Switch either={isViewMore}>
                      <Switch either={size < productCount}>
                        <ViewMore
                          onClick={() => {
                            const next = size + 24
                            changePage(1, next)
                            useSize(next)
                          }}
                        />
                      </Switch>
                      <Pagination
                        current={Number(page)}
                        pageSize={pageSize || params.pageSize}
                        total={productCount}
                        onChange={changePage}
                      />
                    </Switch>
                  </div>
                </>
              ) : null}
              {/* 空数据展示  */}
              {!initLoading && !productList?.length ? (
                <div className={styles['products-list-empty']}>
                  {/* <img src={listEmpty} /> */}
                  {isSearch ? (
                    <p className={styles['empty-tips']}>
                      There is no results for "
                      {params.keywords
                        ? decodeURIComponent(params.keywords)
                        : ''}
                      "
                    </p>
                  ) : (
                    <p className={styles['empty-tips']}>
                      No items found with the filters you selected. Please try
                      clearing your filters to see more options.
                    </p>
                  )}
                  {/* <Link to="/" className={styles['empty-search-link']}>
                    Return Home
                  </Link> */}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <FAQ info={productsData?.data?.faqInfo || {}} />
      </div>
    </>
  )
}

export default Products
